<script>
    import {facet_categories, categories, edit_dossier_categories} from '$lib/store.js';

    export let edit_dossier_context = false;
    export let show_counts = false;
    // Used to create unique 'id' attribute values
    export let filter_location = '';

    let _categories;
    if (edit_dossier_context) {
        _categories = edit_dossier_categories;
    } else {
        _categories = categories;
    }
</script>

<ul>
{#if $facet_categories['Europees Parlement']}
{#each Object.entries($facet_categories['Europees Parlement']) as [category, values]}
    {#if category != 'doc_count'}
    <li>
        <label>
            <input type=checkbox id={['Europees Parlement', category].join('|').replace(/ /g, '_') + filter_location} bind:checked={$_categories[['Europees Parlement', category].join('|')]}>
            {category} {#if show_counts}({Intl.NumberFormat('nl-NL').format(values.doc_count)}){/if}
        </label>
        {#if Object.entries(values).length > 1}
            <ul>
            {#each Object.entries(values) as [sub_category, sub_values]}
                {#if sub_category != 'doc_count'}
                <li>
                    <label>
                        <input type=checkbox id={['Europees Parlement', category, sub_category].join('|').replace(/ /g, '_') + filter_location} bind:checked={$_categories[['Europees Parlement', category, sub_category].join('|')]}>
                        {sub_category} {#if show_counts}({Intl.NumberFormat('nl-NL').format(sub_values.doc_count)}){/if}
                    </label>
                </li>
                {/if}
            {/each}
            </ul>
        {/if}
    </li>
    {/if}
{/each}
{/if}
</ul>
